/**
 * Trusted Partners page copy and limits (FR-30, FR-109, FR-111; MYN-107/108).
 * Its own file rather than an addition to `lib/constants/ui-strings.ts`, which
 * is already past the yellow LOC band (BP-6).
 */
export const TRUSTED_PARTNERS_STRINGS = {
  PAGE_TITLE: 'Trusted Partners',
  HERO_EYEBROW: 'Trusted Partners',
  HERO_TITLE: 'Services Built for Founders',
  HERO_SUBTITLE:
    'Discover vetted service providers and exclusive member offers - handpicked to support your fundraising journey.',
  DIRECTORY_HEADING: 'Partner Directory',
  VIEW_PROFILE: 'View Profile',
  VIEW_ALL_PARTNERS: 'View All Partners',
  HAS_OFFER: 'Has Offer',
  DIRECTORY_EMPTY_TITLE: 'No Trusted Partners yet',
  DIRECTORY_EMPTY_DESCRIPTION: 'Partners appear here once they complete their profile.',
  DIRECTORY_LOAD_FAILED: 'Could not load the partner directory.',
  DIRECTORY_PAGE_TITLE: 'All Trusted Partners',
  BACK_TO_PAGE: 'Trusted Partners',
  SEARCH_PLACEHOLDER: 'Search partners by name',
  SEARCH_LABEL: 'Search partners',
  CATEGORY_LABEL: 'Category',
  CATEGORY_ALL: 'All categories',
  NO_MATCH_TITLE: 'No partners match your filters',
  NO_MATCH_DESCRIPTION: 'Try a different name or category.',
  PERKS_HEADING: 'Startup Perks & Special Offers',
  PERKS_SUBTITLE: 'Exclusive offers from our Trusted Partners - available to My NEXT Raise members only.',
  PERKS_EMPTY_TITLE: 'No live offers right now',
  PERKS_EMPTY_DESCRIPTION: 'Check back soon - partners add new offers regularly.',
  PERKS_LOAD_FAILED: 'Could not load member offers.',
  VIEW_PARTNER: 'View Partner',
  VIEW_ALL_OFFERS: 'View all offers',
  // Startup Perks page (MYN-252).
  PERKS_PAGE_TITLE: 'Startup Perks',
  PERKS_HERO_EYEBROW: 'Startup Perks',
  PERKS_HERO_TITLE: 'Exclusive Offers for Members',
  PERKS_HERO_SUBTITLE:
    'Special pricing and offers from our Trusted Partners, available only to My NEXT Raise members.',
  EXPIRES_PREFIX: 'Expires',
  PROFILE_BREADCRUMB_FALLBACK: 'Partner',
  PROFILE_LOAD_FAILED: 'Could not load this partner.',
  PROFILE_UNAVAILABLE_TITLE: 'This partner is no longer available',
  PROFILE_UNAVAILABLE_DESCRIPTION: 'They may have been removed or are temporarily unavailable.',
  PROFILE_ABOUT: 'About',
  PROFILE_SERVICES: 'Services',
  PROFILE_CATEGORIES: 'Categories',
  PROFILE_WEBSITE: 'Website',
  PROFILE_LINKEDIN: 'LinkedIn',
  PROFILE_VIDEO: 'Promo video',
  PROFILE_OFFERS: 'Current offers',
  /** Resources this partner provided (FR-294, MYN-189). */
  PROFILE_RESOURCES: 'Resources from this partner',
  PROFILE_RESOURCES_ALL: 'Browse all resources',
  CONTACT: 'Contact',
  SCHEDULE: 'Schedule a meeting',
  CONTACT_HEADING: 'Get in touch',
} as const;

/** The preview strip on the Trusted Partners page shows this many partners: one row of three (FR-111, FR-293, A-322). */
export const DIRECTORY_PREVIEW_COUNT = 3;
/** The full list pages at this size, whole rows at 3, 2 and 1 across. */
export const DIRECTORY_PAGE_SIZE = 12;
/** The Trusted Partners page previews this many newest offers; "View all offers" opens the Perks page (FR-30, MYN-252). */
export const PERKS_PREVIEW_COUNT = 6;
/** The only URL param the full list filters on. */
export const DIRECTORY_FILTER_CATEGORY = 'categoryId';

/** HTTP status the Backend answers when a partner is no longer listed (TRUSTED_PARTNER_NOT_AVAILABLE). */
export const PARTNER_NOT_AVAILABLE_CODE = 'TRUSTED_PARTNER_NOT_AVAILABLE';
